import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const materialDeliveryImageStatus = enumerated({
  pending: 'Pendente',
  success: 'Sucesso',
  failed: 'Falhou',
})

export const acceptedFormat = enumerated({
  png: 'PNG',
  jpg: 'JPG',
  webp: 'WEBP',
})

export const materialDeliveryImageObject = z.object({
  id: z.string().uuid(),
  materialDeliveryId: z.string().uuid(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  description: z.string().nullish(),
  position: z.number().int().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  status: materialDeliveryImageStatus,
})

export type MaterialDeliveryImageType = z.infer<typeof materialDeliveryImageObject>

export const propertyMap = {
  id: sql`material_delivery_image.id`,
  materialDeliveryId: sql`material_delivery_image.material_delivery_id`,
  gcsIdentifier: sql`material_delivery_image.gcs_identifier`,
  url: sql`material_delivery_image.url`,
  description: sql`material_delivery_image.description`,
  position: sql`material_delivery_image.position`,
  createdAt: sql`material_delivery_image.created_at`,
  updatedAt: sql`material_delivery_image.updated_at`,
  synchronizedAt: sql`material_delivery_image.synchronized_at`,
  deletedAt: sql`material_delivery_image.deleted_at`,
  status: sql`material_delivery_image.status`,
}
